module.exports = __webpack_public_path__ + "static/media/hotelPageStaffIcon.8611ee63.png";